<template>
  <v-app>
    <Navbar />
    <v-content>
      <router-view></router-view>
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
export default {
  name: "App",
  components: {
    Navbar: Navbar,
    Footer: Footer
  },
  data: () => ({
    //
  })
};
</script>

<style lang="stylus">

html {
  font-family: "Galdeano", sans-serif;
  width: 98%;
  margin-left: 1%;
  background-color: black;
}

body {
  font-family: "Galdeano", sans-serif !important;
}

p {
  font-family: "Galdeano", sans-serif;
}

h1,
h2,
h3 {
  font-family: "Bubblegum Sans", cursive;
}
</style>
